import { useSizeStore } from '@/stores/Configurator/SizeStore';
import type { ImageDimensions } from '@/types/Configurator/ImageDimensions';
import { ImageCutoutEnum } from '@/types/Enums/ImageCutoutEnum';

export function useImage() {
  function getImageCutout(imageDimensions: ImageDimensions): ImageCutoutEnum {
    if (!imageDimensions.width || !imageDimensions.height) {
      // Return square if no cutout is found
      return ImageCutoutEnum.Square;
    }

    // Landscape
    if (imageDimensions.width > imageDimensions.height) {
      return ImageCutoutEnum.Landscape;
    }

    // Portrait
    if (imageDimensions.width < imageDimensions.height) {
      return ImageCutoutEnum.Portrait;
    }

    // Square
    return ImageCutoutEnum.Square;
  }

  async function getImageDimensions(file: File): Promise<ImageDimensions> {
    // Initialize dimensions variables
    let width = undefined as number | undefined;
    let height = undefined as number | undefined;

    // Initialize reader and image
    const reader = new FileReader();
    reader.onload = event => {
      const image = new Image();
      image.onload = () => {
        width = image.width;
        height = image.height;
      };
      image.src = event.target?.result as string;
    };

    reader.readAsDataURL(file);

    // Wait until the image is fully loaded and dimensions are set
    await new Promise(resolve => {
      const checkDimensions = setInterval(() => {
        if (width !== undefined && height !== undefined) {
          clearInterval(checkDimensions);
          resolve(true);
        }
      }, 100);
    });

    // Store dimensions in store
    useSizeStore().imageDimensions.width = width;
    useSizeStore().imageDimensions.height = height;

    // Return the width and height
    return {
      width,
      height,
    };
  }

  return {
    getImageCutout,
    getImageDimensions,
  };
}
